import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@orderna/admin-panel/src/environments/environment';
import { firstValueFrom } from 'rxjs';
import { InitiatePaymentResponseDto } from './dtos/initiate-payment.response.dto';
import { SuccessResponse } from '../shared/success-response';

@Injectable({
  providedIn: 'root',
})
export class PaymentsApiService {
  private readonly API = `${environment.api}/payments`;
  #http = inject(HttpClient);

  async initiatePayment(planId: number): Promise<InitiatePaymentResponseDto> {
    const response = await firstValueFrom(
      this.#http.post<SuccessResponse<InitiatePaymentResponseDto>>(
        `${this.API}/initiate`,
        { planId }
      )
    );
    return response.data;
  }
}
